<template>
  <div class="row">
    <div class="col-12 plan-price-page">
      <!-- <div class="current-plan">
        <div class="plan-text" v-if="companyMemberships.membership">
          <strong class="plan-heading">
            Your Plan is Expired at {{ companyMemberships.expire_date | moment("D MMMM YYYY") }}
          </strong>
          <p>Your Current Plan is {{ companyMemberships.membership.plan.name }} </p>
        </div>
        <div class="plan-text" v-else>
          <strong class="plan-heading">
            Your Trial Period Is Expired
          </strong>
          <p>Please update plan </p>
        </div>
        <div class="plan-btn">
          <button type="button" class="btn btn-outline-primary">
            Upgrade Now
          </button>
        </div>
      </div> -->
      <!-- <div class="breadcrumb-list">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active"><a href="#">Membership</a></li>
        </ol>
      </div> -->
      <!-- <div class="upgrade-package">
        <div class="package-wrapper">
          <div class="plan-card-holder">
            <div class="plan-card" v-for="membership in memberships">
              <div class="plan-name">
                <span>
                  {{ membership.plan.name }}</span>
              </div>
              <div class="plan-head">
                <span class="sup-text">starting from</span>
                <h3>${{ membership.price }}</h3>
                <span class="sup-text">/per month</span>
              </div>
              <div class="plan-body">
                <ul class="package-list" v-html="membership.description">

  <!--                <li>
                    <strong>Employee Creations</strong
                    ><i class="ico ico-check_on"></i>
                  </li>
                  <li>
                    <strong>Employee Creations</strong
                    ><i class="ico ico-check_on"></i>
                  </li>
                  <li>
                    <strong>Employee Creations</strong
                    ><i class="ico ico-cross"></i>
                  </li>
                  <li>
                    <strong>Employee Creations</strong
                    ><i class="ico ico-cross"></i>
                  </li>-->
                <!-- </ul>
                <a
                  href="javascript:void(0)"
                  class="upgrade-btn"
                  v-if="membership.id !== companyMemberships.membership_id"
                  @click="upgradeFun(membership.id)"
                >
                  Update Plan</a>
                <a
                  href="javascript:void(0)"
                  class="upgrade-btn"
                  v-else>
                  Current Plan</a>
              </div>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
      <div class="plan-price-sec">
        <div class="plan-price-sec-hd">
          <h1>Simple and Fair Pricing</h1>
          <p>No start-up fee, No additional charge.</p>
        </div>
        <div class="plan-price-hold">
          <ul class="nav nav-tabs plan-tabs" role="tablist">
            <li class="nav-item" v-for="(membershipPlan,key) in membershipPlans">
              <button class="nav-link" :class="{'active':key===0}" data-toggle="tab"  :data-target="'#'+membershipPlan.slug+'-pkg'" role="tab" aria-selected="true">
                {{ membershipPlan.name }}</button>
            </li>
          </ul>
<!--          <div class="select-country">
            <select class="form-control">
              <option>Select Country</option>
              <option>Select Country2</option>
              <option>Select Country3</option>
            </select>
          </div>-->
          <div class="tab-content plan-tab-content">
            <div v-for="(membershipPlan,key) in membershipPlans" class="tab-pane fade" :class="{'active show':key===0}" :id="membershipPlan.slug+'-pkg'" role="tabpanel" >
              <div class="pkg-types">
<!--                <div v-for="membership in membershipPlan.memberships" class="pkg" >-->
                <div v-for="membership in membershipPlan.memberships" class="pkg" :class="{'popular-pkg':membership.id === companyMemberships.membership_id}">
                  <strong class="popular-title" >Current Plan</strong>
                  <div class="pkg-inner">
                    <h2 class="text-capitalize">{{ membership.name }}</h2>
                    <div class="price-box">
                      <strong class="price"><span style="font-weight: 700;">{{ currencySymbol }}</span> {{ currencyAmountFormat(membership.price) }}<sub class="text-lowercase">/user/month</sub></strong>
                      <span class="sec-note text-lowercase">paid {{ membershipPlan.name }} plan </span>
                    </div>
                    <ul class="pkg-bnf" v-html="membership.description">
  <!--                    <li>For up to 30 staff members</li>-->
                    </ul>
                    <a href="javascript:void(0);" class="btn btn-primary" @click="upgradeFun(membership.id,'plan',membershipPlan.name)"  v-if="membership.id !== companyMemberships.membership_id">Choose Plan</a>
                    <button href="javascript:void(0);" class="btn btn-success" @click="checkoutAlfalaPaymentSubmit"  v-else>
                      <clip-loader :loading="loadingSpin" :size="sizeMain" :color="spinnerColor"></clip-loader>Pay  {{currencyAmountFormat((companyMemberships.allow_staff*companyMemberships.price))}} {{currencySymbol}}</button>
                    <a href="javascript:void(0);" class="free-pkg-tril" @click="upgradeFun(membership.id,'trial',membershipPlan.name)" v-if="membership.id !== companyMemberships.membership_id">Use free trial</a>
                    <a href="javascript:void(0);" class="free-pkg-tril" v-if="membership.id === companyMemberships.membership_id &&  companyMemberships.is_trial===1">Trial expiry at <b>{{ companyMemberships.trial_expire_date | moment('D-MM-YYYY') }}</b> </a>
                    <!--                  <a href="" v-else>&nbsp;</a>-->
                  </div>
                </div>

              </div>

<!--              <div class="prs-tfoot">
                <div class="prs-tfoot-left">
                  <div class="prs-hdg">
                    <strong class="hdg-title">Enter Number of Staff Members</strong>
                    &lt;!&ndash;                <strong class="hdg-subtitle">Enter Number of Staff Members</strong>&ndash;&gt;
                  </div>
                  <form class="calculate-from">
                    <div class="input-wrp">
                      <input type="number" v-model="staffMemberNo" class="form-control">
                    </div>
                    <button class="btn btn-primary" type="button" @click="calculateCost(membershipPlan)">Calculate Cost</button>
                  </form>
                </div>
                <div class="prs-tfoot-rgt" >
                  <div class="prs-hdg">
                    <strong class="hdg-title">Your cost is:</strong>
                    &lt;!&ndash;                <strong class="hdg-subtitle">Total cost:</strong>&ndash;&gt;
                  </div>
                  <div class="prs-hdg-pric" v-show="yourCostPanel">
                    <strong class="hdg-title">PKR {{perMonthCost }} /User per month</strong>
                    <strong class="hdg-title"> {{perYearlyCost }}/ Annum</strong>
                  </div>
                </div>
              </div>-->
            </div>
          </div>

        </div>
      </div>
  <!--    memebrship payment -->
      <div class="modal fade " id="publishModel" tabindex="-1" role="dialog" aria-labelledby="publishModelLabel"
          aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content absence-model publishModel ">
            <div class="modal-header">
              <h5 class="modal-title">You are Publishing your Schedule to your Employees
              </h5>
              <p></p>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span class="ico-cross"></span>
              </button>
            </div>
            <div class="modal-body">
              <div class="sticky-check">
                <label class="custom-check-box ">
                  <input type="checkbox" name="check01" checked="">
                </label>
              </div>


            </div>
            <div class="modal-footer">
              <a href="#" class="btn btn-outline-warning btn-sm" data-dismiss="modal"
                aria-label="Close">Cancel</a>
              <button  class="btn btn-outline-primary btn-sm">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import router from "../../router/router";
import ClipLoader from "vue-spinner/src/ClipLoader";
export default {
  components: {
    ClipLoader
  },
  data() {
    return {
      sizeMain        : '15px',
      spinnerColor: '#00779C',
      loadingSpin : false,
      yourCostPanel:false,
      staffMemberNo:'',
      perMonthCost:'',
      perYearlyCost:'',
      membershipPlans: [],
      companyMemberships: {},
      company_id: this.$store.getters.getSelectedCompany.id,
      currencySymbol: (this.$store.getters.getSelectedCompany.currency) ? this.$store.getters.getSelectedCompany.currency.code : 'PKR',
    };
  },
  serverPrefetch() {},
  created() {
    this.getCompanyMembership();
    this.getAll();
  },
  mounted() {},
  methods: {
    calculateCost(membershipPlan){
    //console.log(this.staffMemberNo,membershipPlan.memberships,'asd');
      var valObj = membershipPlan.memberships.filter((elem, index) => {
       // console.log(elem.allow_staff,'elem.allow_staff',this.staffMemberNo);
        if(this.staffMemberNo <= elem.allow_staff ) {
         var preiceMatch=  elem.price*this.staffMemberNo;
         this.perMonthCost=preiceMatch;
         this.perYearlyCost=preiceMatch*12;
         //  console.log(preiceMatch,'preiceMatch');
           return true;
        }
        return  false
      });

      //console.log(valObj,'valObj');
    //  console.log(this.perYearlyCost,'perYearlyCost');
    },
    checkoutAlfalaPaymentSubmit(){
      this.loadingSpin=true;
      let params = {
        //currency:   (this.$store.getters.getSelectedCompany.currency) ? this.$store.getters.getSelectedCompany.currency.code : 'PKR',
        company_id: this.company_id,
        company_membership_id: this.companyMemberships.id,
      };
      this.$axios
        .get(this.checkoutAlfalaMerchantPayment, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          $('body').append(response.data.result);
          //console.log(response.data.result,'dasdas');
          this.loadingSpin=false;
          document.getElementById("PageRedirectionForm").submit();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //---------- upgrade Fun--------------

    upgradeFun(id,type,paymentPlan) {
      if (confirm("Do you really want to upgrade plan?")) {
        this.$axios
          .post(
            this.$CompanyMembership,
            {
              company_id: this.company_id,
              membership_id: id,
              plan_type: type,
              payment_plan: paymentPlan,
            },
            { headers: this.getAuthHeader() }
          )
          .then((res) => {
            if (res.data.status == 200) {
              this.$router.push({name: 'dashboard'});
             this.$router.go(0);
            }
          });
      }
    },
    getCompanyMembership() {
      let params = {
        company_id: this.company_id,
      };
      this.$axios
        .get(this.$CompanyMembership, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.companyMemberships = response.data.result || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAll() {
      this.$axios
        .get(this.$Membership, {
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.membershipPlans = response.data.result || [];
          console.log(this.membershipPlans);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    currencyAmountFormat(value) {
      return this.currencyFormatter(value).toString().split(".")[0];
    }
  },
};
</script>


<style scoped>
.v-spinner{
  position: absolute;
}
.pkg-types .pkg .h2, .pkg-types .pkg h2{
  font-size: 19px !important;
}
</style>
